<template>
  <v-container
    class="d-flex flex-column justify-center align-center"
    fill-height
  >
    <v-card class="pa-6" max-width="500" flat>
      <div class="mb-5 text-center">
        <p class="text-center text-h5">
          Enter the 6-digit code from your authenticator app
        </p>
      </div>
      <div class="mb-4 text-center">
        <v-otp-input
          v-model="otp"
          label="Enter 6-digit code"
          length="6"
          class="mt-3 ms-n2"
        ></v-otp-input>
        <v-btn
          large
          color="#00B3FF"
          depressed
          @click="verify2FA"
          :loading="verifying"
          class="mt-4"
        >
          Verify
        </v-btn>
      </div>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="2000">
        {{ text }}
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      otp: "",
      verifying: false,
      loading: false,
      userId: this.$route.query.id,
      token: this.$route.query.token,
      snackbar: false,
      snackbarColor: "",
      text: "",
    };
  },
  methods: {
    ...mapActions("auth", ["twoFactorLogin", "logout"]),
    async verify2FA() {
      this.verifying = true;
      try {
        await this.twoFactorLogin({
          userId: this.userId,
          otp: this.otp,
          token: this.token,
        });

        this.snackbarColor = "success";
        this.text = "2FA verification successful!";
        this.snackbar = true;
        setTimeout(() => {
          this.$router.push("/switch-role");
        }, 1500);
      } catch (err) {
        this.snackbarColor = "error";
        this.text =
          err.response?.data?.message ||
          "Verification failed. Please try again.";
        this.snackbar = true;
      } finally {
        this.verifying = false;
      }
    },
    async logout() {
      await this.logout();
      this.$router.push("/login");
    },
  },
};
</script>
